import { TablePagination } from "@mui/material";

export const CustomPagination = ({ pagination,
    onChangePage = () => { },  // Default function
    onChangeRowsPerPage = () => { },  // Default function
    count, rowsPerPage, page, setPage }) => {
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
        onChangePage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setPage(0);
        onChangeRowsPerPage(parseInt(event.target.value, 10));
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    );
};
